import React, { useState, useRef, useCallback, useEffect } from 'react'

//* Components
import Image from 'components/common/Image'
import Icon from 'components/common/Icon'
import LottieAnimation from 'components/common/LottieAnimation'
import AnimationWrap from 'components/common/AnimationWrap'

//* Style
import AboutSectionStyle from './style'

//* Helpers
import { slideWithOpacity } from 'helpers/_gsapFunctions'

//* Lottie
import slotMachineText from 'lottieAnimation/slotMachineText.json'
import { withUIContext } from 'context'

//* Svg
import { Cherry, Clover, Coin, HorseHoe, Lemon } from 'svg'

const AboutSection = ({ winWidth }) => {
	//! States
	const [lottieHover, setLottieHover] = useState(false)
	const [secObj, setSecObj] = useState()

	//! Refs
	const items = useRef([])
	const sectionRef = useRef()
	const iconsGroupRef = useRef()
	const lottieRef = useRef()
	const coinRef = useRef()
	const fullNameRef = useRef()
	const firstOrangeTextRef = useRef()
	const secondOrangeTextRef = useRef()
	const imgRef = useRef()

	useEffect(() => {
		if (items?.current) {
			setSecObj([items.current])
		}
	}, [items, winWidth])

	const startAnimeArr = useCallback((x) => {
		if (x) {
			//! slideWithOpacity(item, stagger, delay)
			slideWithOpacity(
				[
					sectionRef.current,
					fullNameRef.current,
					iconsGroupRef.current,
					firstOrangeTextRef.current,
					lottieRef.current,
					coinRef.current,
					secondOrangeTextRef.current,
					imgRef.current,
				],
				0.1
			)
		}
	}, [])

	return (
		<AboutSectionStyle>
			<AnimationWrap state={secObj} startAnimeArr={startAnimeArr}>
				<div ref={items}>
					<div className='h4 maisonMedium animStartStateSlide aboutText' ref={sectionRef}>
						<Image className='ng-avatar1' src='/images/ng-avatar.png' />
						{winWidth < 1024 ? <br /> : null}
						I’m{' '}
						<span ref={fullNameRef} className='animStartStateSlide orange'>
							NG {winWidth < 768 ? <br /> : null} (Narek Gharibyan).
						</span>
						<br />I travel the country playing slots
						<div className='iconsWrap animStartStateSlide' ref={iconsGroupRef}>
							<Cherry className='icon-cherry' />
							<Lemon className='icon-lemon' />
							<Clover className='icon-clover' />
							<HorseHoe className='icon-horse-shoe' />
							<div className='iconsClone'>
								<Cherry className='icon-cherry' />
								<Lemon className='icon-lemon' />
								<Clover className='icon-clover' />
								<HorseHoe className='icon-horse-shoe' />
							</div>
						</div>
						to share with you my{' '}
						<span ref={firstOrangeTextRef} className='animStartStateSlide orange'>
							real-life experiences
						</span>{' '}
						at casinos
						<div
							ref={lottieRef}
							className='lottieMainWrap animStartStateSlide'
							onMouseEnter={() => setLottieHover(true)}
							onMouseLeave={() => setLottieHover(false)}
						>
							<LottieAnimation
								animData={slotMachineText}
								autoplay={winWidth < 1024 ? true : false}
								onCompletePause={winWidth < 1024 ? false : !lottieHover}
								isPlay={winWidth < 1024 ? true : lottieHover}
								loop={true}
							/>
						</div>
						&nbsp;. I post both my wins
						<div ref={coinRef} className='animStartStateSlide coinWrap'>
							<Coin className='icon-coin'/>
						</div>
						and my losses so I don’t give anyone the
						<span ref={secondOrangeTextRef} className='animStartStateSlide orange'>
							{' '}
							illusion
						</span>{' '}
						that gambling is a
						<Image ref={imgRef} className='animStartStateSlide ng-avatar2' src='/images/ngAvatar.png' /> winning proposition.
					</div>
				</div>
			</AnimationWrap>
		</AboutSectionStyle>
	)
}

export default withUIContext(AboutSection, ['winWidth'])
